"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThemeProviderWrapper = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _styledComponents = require("styled-components");
var _hexRgb2 = _interopRequireDefault(require("hex-rgb"));
var _selectors = require("../../bus/auth/selectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var ThemeProviderWrapper = exports.ThemeProviderWrapper = function ThemeProviderWrapper(_ref) {
  var children = _ref.children;
  var theme = (0, _reactRedux.useSelector)(_selectors.getTheme);
  (0, _react.useEffect)(function () {
    if (theme) {
      var style = global.document.createElement('style');
      var _hexRgb = (0, _hexRgb2.default)(theme.primaryColor),
        red = _hexRgb.red,
        green = _hexRgb.green,
        blue = _hexRgb.blue;
      style.innerHTML = "\n        :root {\n          --ts-primary-color: ".concat(theme.primaryColor, ";\n          --ts-primary-color-red: ").concat(red, ";\n          --ts-primary-color-green: ").concat(green, ";\n          --ts-primary-color-blue: ").concat(blue, ";\n        }\n      ");
      global.document.head.appendChild(style);
      return function () {
        style.remove();
      };
    }
  }, [theme]);
  return /*#__PURE__*/_react.default.createElement(_styledComponents.ThemeProvider, {
    theme: theme
  }, children);
};